<template>
  <OTButton @click="toggleMusic">
    <AudioStoppedIcon v-if="isPlaying" />
    <AudioPlayingIcon v-else />
  </OTButton>
</template>

<script setup>
import { ref, inject, nextTick, onMounted } from "vue";
import OTButton from "./OTButton.vue";
import AudioPlayingIcon from "./icons/AudioPlayingIcon.vue";
import AudioStoppedIcon from "./icons/AudioStoppedIcon.vue";

const audioManager = inject("audioManager");
const themeSong = audioManager.getAudio("themeSong");
const isPlaying = ref(false);

const toggleMusic = () => {
  const initialState = isPlaying.value;
  if (isPlaying.value) {
    themeSong.pause();
    themeSong.currentTime = 0;
  } else {
    themeSong.play();
  }
  nextTick(() => {
    if (isPlaying.value === initialState) {
      isPlaying.value = !initialState;
    }
  });
};

onMounted(() => {
  themeSong.addEventListener("pause", () => {
    isPlaying.value = false;
  });

  themeSong.addEventListener("play", () => {
    isPlaying.value = true;
  });

  themeSong.addEventListener("ended", () => {
    isPlaying.value = false;
  });
});
</script>

<style scoped lang="scss">
button {
  position: fixed;
  bottom: 10px;
  right: 10px;
  z-index: 1000;
  min-width: 32px !important;
  text-decoration: none;
  svg {
    width: 32px;
    height: 32px;
  }
}
</style>
